<template>
  <router-view name="main" />
</template>

<script>
export default {
  components: {},
}
</script>
